import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { UserSession } from '@mem-shared/user-session';

/**
 * Will take user to the landing page if already authenticated
 */
@Injectable()
export class PreLoginGuard implements CanActivate {
  constructor(private userSession: UserSession, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.userSession.isDataLoaded) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pre-login.guard.ts